import store from '@/store/index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import _ from 'lodash';
const otherUtils = {
    /**
     *
     * @param {string} value 权限平台的按钮权限值
     * @return 权限检查方法
     */
    getHasAuth(value) {
        let isExist = false;
        const btnPermissionsArr = store.getters.btnPermissions;
        if (btnPermissionsArr === undefined || btnPermissionsArr === null) {
            return false;
        }
        if (btnPermissionsArr.indexOf(value) > -1) {
            isExist = true;
        } else {
            isExist = false;
        }
        return isExist;
    },
    /**
    *
    * @param {array} arr 需要去重的数组
    * @param {string} key 判断数组重复的唯一key
    * @return 去重
    */
    distinctData(arr, key) {
        // 数组去重
        const obj = {};
        arr = arr
            .filter(i => !!i[key])
            .reduce(function (item, next) {
                if (!obj[next[key]]) {
                    obj[next[key]] = item.push(next);
                }
                return item;
            }, []);
        return arr;
    },
    // 工具函数：转excelTitle对象
    toExcelTitle(item) {
        return {
            name: item.label,
            property: item.prop
        };
    },
    // 根据fixed属性排序columns，fixed:'left'在前，fixed:'right'在后
    sortColumnsByFixed(currentColumns, toExcelTitle = otherUtils.toExcelTitle) {
        // 只处理非隐藏的列
        const visibleColumns = currentColumns.filter(col => !col.hiddenColumn);
        // 左固定
        const leftFixed = visibleColumns.filter(col => col.fixed === 'left');
        // 右固定
        const rightFixed = visibleColumns.filter(col => col.fixed === 'right');
        // 中间
        const center = visibleColumns.filter(col => !col.fixed);

        // 合并顺序：左-中-右
        const allList = [
            ...leftFixed,
            ...center,
            ...rightFixed
        ];

        // 去重
        const seen = new Set();
        const _columns = allList.filter(item => {
            if (seen.has(item.prop)) return false;
            seen.add(item.prop);
            return true;
        });
        return _columns?.map(toExcelTitle) || [];
    },
    async getDictDataList(columns = [], otherDict = []) {
        try {
            const columnsDictCodes = columns.filter(it => it.optionsKey).map(el => el.optionsKey) || [];
            const dictCodes = [...columnsDictCodes, ...otherDict].join(',') || '';
            if (!dictCodes) {
                return {};
            }
            const res = await getDictDataApi({
                dictCodes: dictCodes
            });
            return res.data;
        } catch (error) {
            return {};
        }
    },

    codesToNames(codes, dictObj) {
        const names = [];
        const codesArr = codes ? codes.split(',') : [];
        if (codesArr && codesArr.length) {
            codesArr.forEach((key) => {
                if (dictObj && dictObj[key]) {
                    names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                }
            });
        }
        return names.join(',');
    },
    /**
    *
    * @param {object} obj 查询条件对象
    * @param {object} operators 查询条件的筛选条件,等于、不等于...
    * @return 去重
    */
    convertObject(obj, operators) {
        // console.log('convertObject:', obj, operators);
        const dynamicOptQuery = {};
        // 为每个字段创建查询条件
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                if (value === undefined) continue;
                dynamicOptQuery[key] = {
                    // 默认EQ
                    operator: _.isObject(operators) ? operators[key] || 'EQ' : 'EQ', // 默认操作符
                    // 默认用[]传参数
                    values: Array.isArray(value) ? value : [_.get(obj, key)] || []
                };
            }
        }
        // 返回转换后的对象
        return {
            dynamicOptQuery
        };
    },
    // 脱敏方法
    desensitization: {
        // 手机号脱敏：保留前3位和后4位
        mobile: function (mobile) {
            if (!mobile || mobile.length < 7) return mobile;
            return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        },

        // 电话号码脱敏：保留区号和最后4位
        phone: function (phone) {
            if (!phone) return phone;

            // 处理带区号的电话号码
            if (phone.includes('-')) {
                const parts = phone.split('-');
                if (parts.length === 2) {
                    // eslint-disable-next-line no-magic-numbers
                    return parts[0] + '-****' + parts[1].slice(-4);
                }
            }

            // 处理不带区号的电话号码
            if (phone.length >= 8) {
                // eslint-disable-next-line no-magic-numbers
                return '****' + phone.slice(-4);
            }

            return phone;
        },

        // 地址脱敏：保留前6个字符
        address: function (address) {
            if (!address) return address;
            if (address.length <= 6) return address;
            return address.substring(0, 6) + '****';
        },

        // 传真号码脱敏：与电话相同
        fax: function (fax) {
            return this.phone(fax);
        },

        // 邮箱脱敏：保留前2个字符和@后面部分
        email: function (email) {
            if (!email || !email.includes('@')) return email;

            const parts = email.split('@');
            if (parts[0].length <= 2) {
                return parts[0] + '****@' + parts[1];
            }

            return parts[0].substring(0, 2) + '****@' + parts[1];
        },
        // 身份证号码脱敏：保留前6位和后4位
        idCard: (idCard) => {
            if (!idCard) return idCard;

            // 处理15位身份证
            // eslint-disable-next-line no-magic-numbers
            if (idCard.length === 15) {
                // eslint-disable-next-line no-magic-numbers
                return idCard.substring(0, 6) + '******' + idCard.substring(12);
            }

            // 处理18位身份证
            // eslint-disable-next-line no-magic-numbers
            if (idCard.length === 18) {
                // eslint-disable-next-line no-magic-numbers
                return idCard.substring(0, 6) + '********' + idCard.substring(14);
            }

            // 其他情况
            if (idCard.length > 10) {
                const visibleStart = Math.min(6, Math.floor(idCard.length / 3));
                const visibleEnd = Math.min(4, Math.floor(idCard.length / 4));
                const hiddenLength = idCard.length - visibleStart - visibleEnd;
                return idCard.substring(0, visibleStart) + '*'.repeat(hiddenLength) + idCard.substring(idCard.length - visibleEnd);
            }

            return idCard;
        }
    }

};
export default otherUtils;
